import React, { useState } from "react";
import "../css/StudyMethod.css";

import line from "../images/line.png";
import StudyNavigationItem from "./buttons/StudyNavigationItem";
import Description from "./methods/Description";
import Lesson from "./methods/Lesson";
import Material from "./methods/Material";
import Requirements from "./methods/Requirements";

const StudyMethod = () => {
    const [navigationItem, setNavigationItem] = useState(0);

    const handleNavigation = (id) => {
        setNavigationItem(id);
    };

    const handleContent = (id) => {
        if (id === 0) {
            return <Description />;
        }
        if (id === 1) {
            return <Lesson />;
        }
        if (id === 2) {
            return <Material/>;
        }
        if (id === 3) {
            return <Requirements  />;
        }
    };

    return (
        <div className="StudyMethod" id="study">
            <div className="study-container container padding">
                <div className="study-header">
                    <div className="study-title">
                        <h1>
                            MÉTODO{" "}
                            <span>
                                DE ESTUDIO
                                <img src={line} alt="underline" />
                            </span>
                        </h1>
                    </div>
                </div>
                <div className="study-content">
                    <div className="study-content-navigation">
                        <StudyNavigationItem
                            active={navigationItem === 0 ? true : false}
                            id={0}
                            item={"Descripción"}
                            handleNavigation={handleNavigation}
                        />
                        <StudyNavigationItem
                            active={navigationItem === 1 ? true : false}
                            id={1}
                            item={"Clases"}
                            handleNavigation={handleNavigation}
                        />
                        <StudyNavigationItem
                            active={navigationItem === 2 ? true : false}
                            id={2}
                            item={"Material"}
                            handleNavigation={handleNavigation}
                        />
                        <StudyNavigationItem
                            active={navigationItem === 3 ? true : false}
                            id={3}
                            item={"Requisitos"}
                            handleNavigation={handleNavigation}
                        />
                    </div>
                    <div className="study-information">
                        {handleContent(navigationItem)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudyMethod;
